import React, {useCallback} from 'react';
import type {NationalAgent} from 'services/agent/types';
import {useLocalization} from 'localization';
import {CheckboxField, Spacer} from 'components';
import {useUniqueFieldId} from 'components/fields/hooks/useUniqueFieldId';

type Props = {
  agent: NationalAgent;
  existsInEbba: boolean;
  onAgentChanged: (agent: NationalAgent) => void;
};

export const AgentVerifiedCheckbox: React.FC<Props> = ({
  agent,
  existsInEbba,
  onAgentChanged,
}) => {
  const {t} = useLocalization();
  const fieldId = useUniqueFieldId('verified');

  const handleChange = useCallback(
    (verified: boolean) => onAgentChanged({...agent, verified}),
    [agent, onAgentChanged],
  );

  return existsInEbba ? (
    <>
      <CheckboxField
        fieldId={fieldId}
        name="verified"
        boxLabel={t('form.global.field.verified.label')}
        value={agent.verified ?? false}
        variant="button"
        onChange={handleChange}
      />
      <Spacer size={4} />
    </>
  ) : null;
};
